<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-03 20:00:12
 * @LastEditors: jing
 * @LastEditTime: 2020-12-11 18:36:35
 * @Description: file content
 -->

<template>
  <div class="container" style="padding-bottom:50px;">
    <remote-script
      charset="utf-8"
      src="https://assets.rurushishi.com/h5/lib/jquery/jquery-1.10.2.min.js"
    ></remote-script>
    <remote-link src="/sharelib/css/index.css?v=2"></remote-link>
    <remote-script charset="utf-8" src="/sharelib/sharelib.js"></remote-script>
    <!-- <div v-if="saleropenid == openid">
      <div class="tab">
        <router-link :to="'/vcard3/home?' + tabcard1Param">模版一</router-link>
        <router-link :to="'/vcard3/tabcard2?' + tabcard2Param"
          >模版二</router-link
        >
        <router-link :to="'/vcard3/tabcard3?' + tabcard3Param"
          >模版三</router-link
        >
      </div>

      <router-view class="routerview"></router-view>
    </div>
    <router-view v-if="saleropenid !== openid"></router-view> -->
    <BaseSplash v-if="showSplash"></BaseSplash>
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from "vue";
import wx from "weixin-js-sdk";
import util from "@/utils/utils";
import Cookies from "js-cookie";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import request from "@/utils/request";
import global_ from "../../../global.config";
import BaseSplash from "./components/BaseSplash";
export default {
  props: {},
  components: {
    BaseSplash
  },
  data() {
    return {
      selfAction: {
        //弹出自行动播放音乐
        promptSound: new Audio(
          "https://assets.rurushishi.com/sharelib/iPhone.mp3"
        ),
        triggerTime: 12, //等待时间秒
        passedTime: 0, //秒
        saleropenid: "", //分享人openid。
        openid: "" //本人openid
      },
      //获取项目信息
      pcConfig: {
        callBtn: null, //致电 btns type 8
        navBtn: null, // 导航 btns type 9
        askBtn: null, // 咨询 btns type 10
        btns: [], //自定义按钮
        card: null //用户名片信息
      },
      uuid: "", //前端生成的唯一id
      cookieKeys: {
        cardid: "usercard2_cardid",
        uuid: "usercard2_uuid",
        masteropenid: "usercard2_masteropenid",
        projectid: "usercard2_projectid"
      },
      cookieDuration: 60 * 10,
      showSplash: true
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isLoading",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo",
      "sourceGzhInfo"
    ]),
    tabcard1Param() {
      let saleropenid = this.$route.query.saleropenid;
      if (this.global.isLoc && !saleropenid) {
        saleropenid = this.$openid;
      }
      let param = `saleropenid=${saleropenid}&id=177653&psn=f7826613e69643a7aec0428aa5b15ed4&entry=zxslzx&t9id=177645&t9psn=feb80466fdba4aa2a9ce67175161fed3`;
      return param;
    },
    tabcard2Param() {
      let saleropenid = this.$route.query.saleropenid;
      if (this.global.isLoc && !saleropenid) {
        saleropenid = this.$openid;
      }
      let param = `entry=${this.$route.query.entry}&id=${
        this.$route.query.id
      }&psn=${this.$route.query.psn}&saleropenid=${saleropenid}&backhome=home`;
      return param;
    },
    tabcard3Param() {
      let saleropenid = this.$route.query.saleropenid;
      if (this.global.isLoc && !saleropenid) {
        saleropenid = this.$openid;
      }
      let url = `${location.protocol}//${
        location.host
      }/h5/vcard2?saleropenid=${saleropenid}`;
      if (!this.isInMiniProgram || util.checkIsHaveOldMp()) {
        // 非小程序环境下加上back按钮
        url = util.addUrlParamFromObj(url, {
          backhome: "back"
        });
      }
      let param = util.getYqRsMakeLink(url);
      return param;
    }
  },
  methods: {
    ...mapMutations({
      SET_RECEIVESPREADINFO: "SET_RECEIVESPREADINFO",
      SET_SHARESPREADINFO: "SET_SHARESPREADINFO",
      SET_PAGEINFO: "SET_PAGEINFO",
      SET_SOURCEGZHINFO: "SET_SOURCEGZHINFO"
    }),
    // clickTab(pagename) {
    //   this.current = pagename;
    //   if (pagename == "xm") {
    //     // let url = `${location.protocol}//${
    //     //   location.host
    //     // }/h5/vcard3/home?saleropenid=${
    //     //   this.$openid
    //     // }&id=177653&psn=f7826613e69643a7aec0428aa5b15ed4&entry=zxslzx&t9id=177645&t9psn=feb80466fdba4aa2a9ce67175161fed3`;
    //     // window.location.href = url;
    //   } else if (pagename == "sl") {
    //     let url = `${location.protocol}//${
    //       location.host
    //     }/h5/vcard2?saleropenid=${this.$openid}`;
    //     if (!this.isInMiniProgram || util.checkIsHaveOldMp()) {
    //       // 非小程序环境下加上back按钮
    //       url = util.addUrlParamFromObj(url, {
    //         backhome: "back"
    //       });
    //     }
    //     // debugger;
    //     let a = util.openYqRsMakeLink(url);
    //     console.log("a------", a);
    //     // this.$router({
    //     //   path: "/vcard2",
    //     //   query: a
    //     // });
    //     this.$router.push(`/vcard2?${a}`);
    //   }
    // },
    // 设置内容自行动
    setSelfAction: function() {
      let that = this;
      comreq.getPageSelfConfig(that.pageInfo.PageId).then(function(data) {
        // 设置了自行动，开启定时器
        if (data) {
          let zxdObj = Cookies.get("t9_20200131_self_" + that.pageInfo.PageId);
          if (zxdObj) {
            that.showSelfAction(1);
          } else {
            let tmpInterval = setInterval(function() {
              that.selfAction.passedTime++;
              if (that.selfAction.triggerTime == that.selfAction.passedTime) {
                that.showSelfAction(0);
                let inFifteenMinutes = new Date(
                  new Date().getTime() + 365 * 24 * 60 * 60 * 1000
                );
                Cookies.set("t9_20200131_self_" + that.pageInfo.PageId, 1, {
                  expires: inFifteenMinutes
                });
                clearInterval(tmpInterval);
              }
            }, 1000);
          }
        }
      });
    },
    showSelfAction: function(type) {
      let option = {
        pageid: this.pageInfo.PageId,
        openid: this.$openid,
        refereeopenid: this.$refereeopenid,
        passport: this.$passport,
        apiurl: this.global.API_URL
      };
      let chaturl = util.getGzhChatUrl(this);
      if (chaturl) {
        option.chaturl = chaturl;
      }
      if (type == 1) {
        option.type = 1;
      } else {
        // 自行动首次弹出
        this.selfAction.promptSound.play();
      }
      ShareLibSDK.showPageSelfConfig(option);
    },
    // 分享后页面
    showShareAfterAction: function() {
      let that = this;
      if (that.pageInfo.Showsharepage == 1) {
        let shareLibOption = {
          pageid: parseInt(that.pageInfo.PageId),
          openid: that.$openid,
          passport: that.$passport,
          apiurl: that.global.API_URL,
          refereeopenid: that.$refereeopenid
        };
        if (window.ShareLibSDK) {
          window.ShareLibSDK.showShareWin(shareLibOption);
        } else {
          let tmpInterval = setInterval(() => {
            if (window.ShareLibSDK) {
              window.ShareLibSDK.showShareWin(shareLibOption);
            }
          }, 500);
        }
      }
    },
    // 发送浏览时长
    sendTime(guid) {
      let that = this;
      let postObj = {
        openid: this.$openid,
        pageid: this.$pageid,
        tempid: guid,
        channelid: "",
        refereeopenid: this.$refereeopenid,
        projectid: this.pageInfo.Pid,
        psn: this.$psn
      };
      comreq.actIp(this, postObj);
    },
    // 开始统计浏览时长
    setSendTime() {
      let that = this;
      let guid = util.getGuid();
      setTimeout(function() {
        that.sendTime(guid);
        setInterval(function() {
          that.sendTime(guid);
        }, 3000);
      }, 1000);
    },

    // ------统计-----
    // 获取项目信息
    setUuid: function() {
      var uuid = Cookies.get("usercard2_uuid");
      if (uuid) {
        this.uuid = uuid;
      } else {
        this.uuid = util.getGuid();
        Cookies.set(this.cookieKeys.uuid, this.uuid, this.cookieDuration);
      }
    },
    selectCardByProjectid() {
      let saleropenid = this.$route.query.saleropenid;
      if (this.global.isLoc && !saleropenid) {
        saleropenid = this.$openid;
      }
      let that = this;
      return new Promise(function(resolve, reject) {
        request
          .get(global_.API_URL, {
            action: "/electroniccard/ElectronicCardAction/getElectronicCard",
            requestParam: {
              projectid: that.pageInfo.Pid,
              state: 1,
              masteropenid: saleropenid
            }
          })
          .then(function(response) {
            if (response.obj) {
              var data = response.obj;
              that.pcConfig.card = data;
              Cookies.set(
                that.cookieKeys.cardid,
                that.pcConfig.card.id,
                that.cookieDuration
              );
              that.saveCardLog();
              setInterval(() => {
                that.saveCardLog();
              }, 5000);
              if (data.btns) {
                data.btns.forEach(function(e) {
                  if (e.type == 9) {
                    that.pcConfig.callBtn = e;
                  } else if (e.type == 10) {
                    that.pcConfig.navBtn = e;
                  } else if (e.type == 11) {
                    that.pcConfig.askBtn = e;
                  } else {
                    that.pcConfig.btns.push(e);
                  }
                });
              }
            }
          });
      });
    },
    saveCardLog(imageid = "", btnid = "") {
      let that = this;
      let saleropenid = that.$route.query.saleropenid;
      if (that.global.isLoc && !saleropenid) {
        saleropenid = that.$openid;
      }
      return new Promise(function(resolve, reject) {
        request
          .get(global_.API_URL, {
            action: "/electroniccard/ElectronicCardAction/saveCardLog",
            requestParam: {
              obj: {
                cardid: that.pcConfig.card.id, //电子名片模板id
                uuid: that.uuid, //前端生成的唯一标识
                masteropenid: saleropenid, //当前电子名片所属人的openid
                imageid: imageid, //如果是浏览的户型图详情，需要提交户型图的id
                btnid: btnid, //功能按钮的id
                referenceopenid: Cookies.get("openid"),
                // referenceopenid: that.$route.query.saleropenid,
                projectid: that.pcConfig.card.projectid
              }
            }
          })
          .then(function(data) {});
      });
    },
    wxShare: function(imageid = "", btnid = "") {
      let that = this;
      let saleropenid = that.$route.query.saleropenid;
      if (that.global.isLoc && !saleropenid) {
        saleropenid = that.$openid;
      }
      return new Promise(function(resolve, reject) {
        request
          .get(global_.API_URL, {
            action: "/electroniccard/ElectronicCardAction/saveShare",
            requestParam: {
              obj: {
                cardid: that.pcConfig.card.id, //电子名片模板id
                uuid: that.uuid, //前端生成的唯一标识
                masteropenid: saleropenid, //当前电子名片所属人的openid
                imageid: imageid, //如果是浏览的户型图详情，需要提交户型图的id
                btnid: btnid //功能按钮的id
              }
            }
          })
          .then(function(data) {
            console.log("测试分享", data);
          })
          .catch(function(error) {
            console.log(error);
          });
      });
    }
  },
  beforeCreate() {},
  created() {
    const that = this;
    that.saleropenid = that.$route.query.saleropenid;
    that.openid = this.$openid;
    that.setUuid();
    let id = 0;
    let psn = "";
    if (that.$route.query.id && that.$route.query.psn) {
      let t9_20200131_initObj = {
        id: that.$route.query.id,
        psn: that.$route.query.psn
      };
      if (that.$route.query.refereeopenid) {
        t9_20200131_initObj.refereeopenid = that.$route.query.refereeopenid;
      }
      if (that.$route.query.rscuid) {
        t9_20200131_initObj.rscuid = that.$route.query.rscuid;
      }
      Cookies.set("t9_20200131_init", JSON.stringify(t9_20200131_initObj), {
        expires: new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000)
      });
      id = that.$route.query.id;
      psn = that.$route.query.psn;
    } else {
      let initObj = Cookies.get("t9_20200131_init");
      if (initObj) {
        initObj = JSON.parse(initObj);
        if (initObj.id && initObj.psn) {
          id = initObj.id;
          psn = initObj.psn;
          let shareSpreadInfo = that.shareSpreadInfo;
          shareSpreadInfo.id = initObj.id;
          shareSpreadInfo.psn = initObj.psn;
          this.SET_SHARESPREADINFO(shareSpreadInfo);

          let receiveSpreadInfo = that.receiveSpreadInfo;
          receiveSpreadInfo.id = initObj.id;
          receiveSpreadInfo.psn = initObj.psn;
          if (initObj.refereeopenid) {
            receiveSpreadInfo.refereeopenid = initObj.refereeopenid;
          }
          if (initObj.rscuid) {
            receiveSpreadInfo.rscuid = initObj.rscuid;
          }
          this.SET_RECEIVESPREADINFO(receiveSpreadInfo);
        }
      }
    }

    let tmpTxt = "AI";
    if (util.checkIsHuafa()) {
      tmpTxt = "";
    }

    if (id && psn) {
      // 获取页面信息
      comreq.getPageInfo(id, psn, that).then(function(pageInfo) {
        that.SET_PAGEINFO(pageInfo);
        if (that.$route.query.isnew && that.$route.query.isnew == 1) {
          that.isShowCreateAfterGuide = true;
        }
        console.log("pageInfo--", that.pageInfo.Pid);
        that.selectCardByProjectid();
      });

      // 设置内容自行动
      util
        .checkMapStateCallback(that, [
          "pageInfo",
          "shareSpreadInfo",
          "userInfo"
        ])
        .then(() => {
          // 在线售楼中心，遇到销售或者职业经纪人带上rscuid传播。在楼盘详情如果有rscuid，销售员列表就只展示这个人。
          if (util.checkIsHuafa()) {
            console.log("haufa==>", this.userInfo);
            //不走 内容自行动、获取渠道、agentInfo信息
            if (this.userInfo.salerOrAgent == true) {
              let shareSpreadInfo = that.shareSpreadInfo;
              shareSpreadInfo.rscuid = that.$openid;
              this.SET_SHARESPREADINFO(shareSpreadInfo);
            }
            that.global.SHARE_CALLBACK_OK = function() {
              comreq.actShare(that);
              // 先隐藏了分享后页面
              // that.showShareAfterAction();
            };
          } else {
            comreq.getUserIntegralInfo().then(userInfo => {
              if (
                userInfo.isSale == true ||
                (userInfo.isAgent == true &&
                  userInfo.agentInfo &&
                  userInfo.agentInfo.authtype == 2)
              ) {
                let shareSpreadInfo = that.shareSpreadInfo;
                shareSpreadInfo.rscuid = that.$openid;
                this.SET_SHARESPREADINFO(shareSpreadInfo);
              }
              // 微信网页
              // 需要设置分享
              that.global.SHARE_CALLBACK_OK = function() {
                comreq.actShare(that);
                // 先隐藏了分享后页面
                // that.showShareAfterAction();
                that.wxShare();
              };
            });
            comreq
              .getChannelInfoByPageId(that.pageInfo.PageId)
              .then(function(sourceGzhInfo) {
                that.SET_SOURCEGZHINFO(sourceGzhInfo);
              });
            if (location.href.indexOf("noguide=1") > -1) {
            } else {
              // 小原作为上级，没有fid这种不调用自行动，并去掉提示音
              if (that.$refereeopenid) {
                that.setSelfAction();
              }
            }
          }

          that.setSendTime();
          // 上报设备信息
          comreq.actMt(that);
        });
    } else {
      util.queryCheck(
        {
          id: "PageId",
          psn: "防刷参数"
        },
        that.$route.query
      );
    }
  },
  mounted() {
    Vue.prototype.$audio = new Audio(
      "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard3/audio.m4a"
    );
    wx.ready(() => {
      if (Vue.prototype.$audio) {
        Vue.prototype.$audio.play();
      }
    });
  }
};
</script>
<style lang="stylus" scoped>
// px 转换 rem
p2r(designpx) {
  $rem = 100px;
  return (designpx / $rem) rem;
}
.tab
  position fixed
  left 0
  right 0
  top  0
  display flex
  width 100%
  height 1rem
  background-color #ededed
  z-index  10
  .tab-item
    position relative
    height 100%
    display flex
    justify-content center
    align-items center
    flex 1
    height p2r(97px)
    background #EDEDED
    color #000
  .tab-item.active::after
    position: absolute;
    content: '';
    width: p2r(70px);
    height: p2r(4px);
    background: #D43936;
    color #D43936
    border-radius: 1px;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
  a
    position relative
    height 100%
    display flex
    justify-content center
    align-items center
    flex 1
    height 1rem
    background #EDEDED
    color #000
  .router-link-active::after
    position: absolute;
    content: '';
    width: p2r(70px);
    height: p2r(4px);
    background: #D43936;
    color #D43936
    border-radius: 1px;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
.routerview
  padding-top 1rem
</style>
